var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrologio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H11.25C11.25 12.268 11.393 12.5155 11.625 12.6495L12 12ZM21.25 12H20.5C20.5 16.6944 16.6944 20.5 12 20.5V21.25V22C17.5228 22 22 17.5228 22 12H21.25ZM12 21.25V20.5C7.30558 20.5 3.5 16.6944 3.5 12H2.75H2C2 17.5228 6.47715 22 12 22V21.25ZM2.75 12H3.5C3.5 7.30558 7.30558 3.5 12 3.5V2.75V2C6.47715 2 2 6.47715 2 12H2.75ZM12 2.75V3.5C16.6944 3.5 20.5 7.30558 20.5 12H21.25H22C22 6.47715 17.5228 2 12 2V2.75ZM12 12H12.75V5.5H12H11.25V12H12ZM12 12L11.625 12.6495L15.3056 14.7745L15.6806 14.125L16.0556 13.4755L12.375 11.3505L12 12Z",
    fill: "#191E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrologio);
export default __webpack_public_path__ + "static/media/orologio.59771564d8dd5945dd046d47d4c7bb3d.svg";
export { ForwardRef as ReactComponent };